/*  ========================================================================
    # Components - Rich Menu Slider
    ========================================================================  */

import React, { useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import useLocalization from '../../hooks/useLocalization';
import Card from '../Card';
import ScrollSlider from '../ScrollSlider';

const RichMenuSlider = ({ cards, type = 'default', intro, readMoreLink }) => {
  const locale = useLocalization();
  const sliderRef = useRef(null);

  // Icons
  const iconArrowRight = useMemo(() => locale('svgSprite') + '#arrow-right', [locale]);

  return (
    <>
      <div className={`c-rich-menu-slider__wrapper c-rich-menu-slider__wrapper--${type}`}>
        {intro || readMoreLink ? (
          <div className='c-rich-menu-slider__intro'>
            {intro && (
              <div className='wysiwyg-block' dangerouslySetInnerHTML={{ __html: intro }}></div>
            )}

            {readMoreLink && (
              <a
                className='c-rich-menu-slider__read-more'
                href={readMoreLink.url}
                title={readMoreLink.title}
                aria-label={readMoreLink.title}
                target={readMoreLink.target}
              >
                {readMoreLink.title}
                <svg viewBox='0 0 20 20' aria-hidden tabIndex='-1'>
                  <use href={iconArrowRight}></use>
                </svg>
              </a>
            )}
          </div>
        ) : null}
        {cards.length > 0 && (
          <>
            <div className='c-rich-menu-slider__list' ref={sliderRef}>
              {cards.map(card => (
                <div className='c-rich-menu-slider__item' key={`list-item-${card.id}`}>
                  <Card
                    headline={card.headline}
                    subheadline={card.subheadline}
                    description={card.description}
                    hasLightboxContent={card.hasLightboxContent}
                    lightboxDescription={card.lightboxDescription}
                    image={card.image}
                    url={card.url}
                    label={card.label}
                    type={card.type}
                  />
                </div>
              ))}
            </div>
            <ScrollSlider scrollAreaRef={sliderRef} scrollBy={410} />
          </>
        )}
      </div>
    </>
  );
};

RichMenuSlider.propTypes = {
  cards: PropTypes.array,
  type: PropTypes.string,
  intro: PropTypes.string,
  readMoreLink: PropTypes.any
};

export default RichMenuSlider;
